import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import { jsx as ___EmotionJSX } from "@emotion/core";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import { FormFieldsetRoot as Root } from "./styled";
import { formFieldsetPropTypes } from "./propTypes";

var FormFieldset = function FormFieldset(props) {
  var children = props.children,
      legend = props.legend,
      restProps = _objectWithoutPropertiesLoose(props, ["children", "legend"]);

  return ___EmotionJSX(Root, restProps, legend && ___EmotionJSX("legend", null, legend), children);
};

FormFieldset.displayName = 'FormFieldset';
FormFieldset.propTypes = process.env.NODE_ENV !== "production" ? formFieldsetPropTypes : {};
export default FormFieldset;